import React from 'react';
import { CircleCheckIcon, CircleXIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceStats } from '../data/content';
export function Difference() {
  return <section className="w-full bg-stone-50 px-5 py-20 sm:py-28" data-id="element-39" data-mp="a5ofw4uob68">
      <div className="mx-auto max-w-5xl" data-id="element-40" data-mp="9vy27fw8200">
        <div className="mx-auto max-w-3xl text-center" data-id="element-41" data-mp="58z702yzusd9">
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-red-500" data-id="element-42" data-mp="57ebaa0y13dt">
            The Restaurant English Ready Difference
          </span>
          <h2 className="mt-5 text-[2rem] font-black leading-[1.08] tracking-tight text-stone-900 sm:text-5xl" data-id="element-43" data-mp="3rgp9e44ehhi9">
            From Hours of Planning to{' '}
            <span className="italic text-red-500" data-id="element-44" data-mp="3dj0oiwac2ad7">5-Minute Prep.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-stone-600 sm:text-base" data-id="element-45" data-mp="3ig0sn1nmh31o">
            Your next 36 weekly lessons are already mapped out. Pick a lesson,
            review the teacher route and answers, then print or open the pages.
            Real restaurant practice without writing every activity from scratch.
          </p>
        </div>

        <dl className="mx-auto mt-11 grid max-w-3xl grid-cols-1 overflow-hidden rounded-xl border border-stone-200 bg-white sm:grid-cols-3" data-id="element-46" data-mp="1f8inhna40m5s">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`px-6 py-7 text-center ${index > 0 ? 'border-t border-stone-200 sm:border-l sm:border-t-0' : ''}`} data-id="element-47" data-mp="1o1dq098703rv" data-mpi={index}>
              <dt className="sr-only" data-id="element-48" data-mp="10ckycoylsi32">{stat.label}</dt>
              <dd data-id="element-49" data-mp="wbhkg8048w4h">
                <span className="block text-3xl font-black text-red-500" data-id="element-50" data-mp="wc11lmhxzghg">
                  {stat.value}
                </span>
                <span className="mt-1.5 block text-[10px] font-bold uppercase tracking-[0.14em] text-stone-500" data-id="element-51" data-mp="1a8e7dyd45tg3">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <div className="mt-14 overflow-hidden rounded-3xl bg-white shadow-xl" data-id="element-52" data-mp="2lrgvxvr7ixna">
          <div className="grid md:grid-cols-2" data-id="element-53" data-mp="2gqb19sdzl0b4">
            <div className="relative bg-stone-100 p-8 sm:p-10" data-id="element-54" data-mp="2orsb6w580vpd">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white text-stone-400" data-id="element-55" data-mp="2otlec1gmkxsm">
                <CircleXIcon className="h-5 w-5" aria-hidden="true" data-id="element-56" data-mp="2xrnl6xn1iknt" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-stone-500" data-id="element-57" data-mp="32rjpkxznge3w">
                Preparing from scratch
              </span>
              <h3 className="mt-3 text-2xl font-bold tracking-wide text-stone-900" data-id="element-58" data-mp="2516s3jfxz50o">
                BEFORE
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-stone-500" data-id="element-59" data-mp="2f1pfgo6pt3nc">
                What building restaurant English lessons yourself can take from
                your week.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-60" data-mp="1mda5wh6crdje">
                {beforeItems.map(item => <li key={item} className="flex items-center gap-3 rounded-full bg-white/70 px-4 py-3 text-sm text-stone-600" data-id="element-61" data-mp="1maxmdzky4v48">
                    <CircleXIcon className="h-4 w-4 shrink-0 text-stone-400" aria-hidden="true" data-id="element-62" data-mp="1jsvmc9u8e3ny" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="relative bg-white p-8 sm:p-10" data-id="element-63" data-mp="19twcinxqc1zd">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-red-500 text-white" data-id="element-64" data-mp="19sbiczfbul21">
                <CircleCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-65" data-mp="10t7yvuc903n0" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-red-500" data-id="element-66" data-mp="w2rhjz5b3xvd">
                Restaurant English Ready
              </span>
              <h3 className="mt-3 text-2xl font-bold tracking-wide text-stone-900" data-id="element-67" data-mp="r46m0d1022d9">
                WITH THE KIT
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-stone-500" data-id="element-68" data-mp="h5hb547iti6i">
                Every lesson follows the same practical structure.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-69" data-mp="d4p1i9uqlb9p">
                {afterItems.map(item => <li key={item} className="flex items-center gap-3 rounded-xl bg-red-50 px-4 py-3 text-sm font-medium text-stone-900" data-id="element-70" data-mp="11vkviieyl8sg">
                    <CircleCheckIcon className="h-4 w-4 shrink-0 text-red-500" aria-hidden="true" data-id="element-71" data-mp="16vqsme3zznhx" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
          <p className="border-t border-stone-100 bg-stone-50 px-6 py-4 text-center text-xs text-stone-500" data-id="element-72" data-mp="x1qfpq2h5dyn">
            Printable materials that make preparing restaurant English lessons
            easier.
          </p>
        </div>
      </div>
    </section>;
}